module.exports = __webpack_public_path__ + "img/purchase-suggestions.5a117c25.svg";